<template>
  <aside class="w-full lg:w-max lg:py-6">
    <div class="filter-container size-full lg:!w-[464px]">
      <div class="lg:max-h-cqh">
        <header class="sticky left-0 top-0 w-full pt-5">
          <button
            type="button"
            class="flex w-full items-center justify-center gap-1 lg:justify-normal"
            @click="open = !open"
          >
            <UiIcon name="mapmarker" class="size-3 text-icon-primary" />
            <p class="text-sm">Посмотреть на карте другие площадки</p>
          </button>
        </header>
        <UiDialog
          v-model="open"
          :position="isLgAndDown ? 'bottom' : 'middle'"
          :swipe-close="isLgAndDown"
        >
          <div
            class="relative mx-auto overflow-scroll rounded-t-3xl bg-primary px-6 pb-5 lg:max-w-screen-xs lg:rounded-3xl"
          >
            <VenueMapList
              :value="venues"
              :active-venue="activeVenue"
              @update:active-venue="selectVenue"
              @close="open = false"
            />
          </div>
        </UiDialog>
      </div>
    </div>
  </aside>
</template>

<script lang="ts" setup>
import type { Nullable } from 'ts-helpers'
import { computed, ref } from 'vue'
import { type Venue, VenueMapList } from '@/5_entities/Venue'
import { useBreakpoint } from '@/6_shared/lib'
import { UiDialog, UiIcon } from '@/6_shared/ui'

type PropType = {
  value: Venue[]
  activeVenue: Nullable<Venue>
}
type EmitType = {
  (e: 'update:activeVenue', venue: Nullable<Venue>): void
}
const props = defineProps<PropType>()
const emit = defineEmits<EmitType>()
const {
  lg: [_, isLgAndDown]
} = useBreakpoint()
const open = ref(false)
const filter = ref('')

const venues = computed(() =>
  props.value.filter((item) => {
    if (!filter.value) return true
    const filterValue = filter.value.toLowerCase()

    return (
      item.title.toLowerCase().includes(filterValue) ||
      item.address?.normalized.toLocaleLowerCase().includes(filterValue) ||
      item.cityName.toLowerCase().includes(filterValue)
    )
  })
)

const selectVenue = (venue: Venue) => {
  emit('update:activeVenue', venue)
  open.value = false
}
</script>

<style scoped>
.filter-container {
  container: map;
  container-type: size;

  @media (max-width: 1024px) {
    container-type: normal;
  }
}
.filter-container ul {
  height: calc(100cqh - 48px - 51px) !important;

  @media (max-width: 1024px) {
    height: fit-content !important;
  }
}
</style>
